module.exports = __webpack_public_path__ + "img/logo-walmart-white.png";